import { render, staticRenderFns } from "./Recibos.vue?vue&type=template&id=56d14684&scoped=true"
import script from "./Recibos.vue?vue&type=script&lang=js"
export * from "./Recibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d14684",
  null
  
)

export default component.exports